import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Container,
  AccordionItem,
  AccordionHeading,
  AccordionHeadingOuter,
  AccordionPanel,
  AccordionToggle
} from "./styles"
import { H2 } from "../typography"
import Markdown from "../markdown"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/free-solid-svg-icons"

const AccordionContent = ({ items, inlineOnMobile, contentsAreComponents, ...rest }) => {
  const [showItems, setShowItems] = useState([])

  const toggleItem = (index) => {
    if (showItems.includes(index)) {
      setShowItems(showItems.filter((item) => item !== index))
    } else {
      setShowItems([...showItems, index])
    }
  }

  useEffect(() => {
    items.map((item, index) => {
      if (!!item.defaultOpen) {
        setShowItems([...showItems, index])
      }
    })
  }, [items, setShowItems])

  const accordionKey = Math.random().toString(36).substring(7)

  return (
    <Container inlineOnMobile={inlineOnMobile} className="ho-accordion" {...rest}>
      {items.map((item, index) => (
        <AccordionItem key={`accordion_${accordionKey}_${index}`} inlineOnMobile={inlineOnMobile}>
          <AccordionHeadingOuter onClick={() => toggleItem(index)}>
            <H2 marginless>
              <AccordionHeading>{item.heading}</AccordionHeading>
            </H2>
            <AccordionToggle rotated={showItems.includes(index)}>
              <FontAwesomeIcon icon={faChevronDown} />
            </AccordionToggle>
          </AccordionHeadingOuter>

          <AccordionPanel show={showItems.includes(index)}>
            {!contentsAreComponents && item.content && <Markdown>{item.content}</Markdown>}
            {contentsAreComponents && item.content}
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Container>
  )
}

AccordionContent.propTypes = {
  items: PropTypes.array.isRequired,
  inlineOnMobile: PropTypes.bool,
  contentsAreComponents: PropTypes.boolean
}

AccordionContent.defaultProps = {
  inlineOnMobile: false,
  contentsAreComponents: false
}

export default AccordionContent
